import React, { Component } from 'react';
import SelectionPopover from 'react-selection-popover';
import Slider from 'react-slick';
import { Button } from 'reactstrap';

import 'sweetalert2/dist/sweetalert2.css';
import language from '../../../../assets/languages/language';
import { questionsettings } from '../../../../common/cbtleftnavigationsettings';
import Loader from '../../../../common/loader';
import { showSuccess } from '../../../../common/toast';
import CBTFinishTest from '../../../Common/CBTFinishTest';
import CBTFlagged from '../../../Common/CBTFlagged';
import CBTNonAttempted from '../../../Common/CBTNonAttempted';
import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';

import { caseCV } from '../../../../common/cbttopnavigationsettings';
import { SecondsToHHMMSS, filterObj, optionsArr } from '../../../../common/constant';
import { clearSelection, highlightString } from '../../../../common/highlightText';
import AppRoutes from '../../../config/AppRoutes';
import { renderHTMLContent } from '../../../../common/function';
/* eslint-disable*/
const longPressDuration = 450;
var attemptedCaseArray = [];
class CFAQuestions extends Component {
  selectionShare;
  constructor(props) {
    super(props);
    this.state = {
      questionsData: [],
      isLoading: true,
      isDataLoading: true,
      token: '',
      idname: '',
      userStatsData: '',
      time: {},
      seconds: this.props.params.timer ? parseInt(this.props.params.timer) : 0,
      showFinishTestPopup: false,
      mockName: '',
      flag: [],
      showSectionReview: false,
      showAttempted: false,
      showUnattempted: false,
      showFlagged: false,
      filter: [],
      showNonAttemptedPopup: false,
      showFlaggedPopup: false,
      selectedQuestionData: [],
      runDecrement: true,
      isNegative: false,
      timerStart: this.props.params.timerStart,
      selectedQuestion: '',
      highlights: [],
      showPopover: false,
      strikeThroughArr: [],
      vpCaseLoader: true,
      questionLoader: true,
      totalQuestionCount: 0,
    };
    this.longPressCountdown = null;
    this.timer = 0;
    this.countDown = this.countDown.bind(this);
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidUpdate = prevProps => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (
      prevProps.params.caseOffset !== this.props.params.caseOffset ||
      prevProps.params.quesOffset !== this.props.params.quesOffset
    ) {
      var data = {
        token: storage_session['token'],
        idname: storage_session['idname'],
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      };
      this.getCases(data);
      this.getUserStats();
      this.getFlagQuestions();
    }
  };

  componentDidMount = async () => {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
    };
    this.getCases(data);
    this.getUserStats();
    // this.getFlagQuestions();
    if (this.props.params.timerStart === 'true') {
      this.timer = setInterval(this.countDown, 1000);
    } else {
      clearInterval(this.timer);
    }
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getMockNamebyId', data).then(async res => {
      this.setState({
        mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
      });
    });
    // getTotalQuestionsCount
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getTotalQuestionsCount', data).then(
      resp => {
        if (resp.success) {
          // console.log('Success --------> ', resp);
          this.setState({
            totalQuestionCount: resp.question,
          });
        } else {
          // console.log('falure --------> ', resp);
        }
      },
    );
  };

  getCases = data => {
    this.setState({
      display_main_loader: 'show_block z-index-1000 bg-white',
      vpCaseLoader: true,
      questionLoader: true,
    });
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getCFAMockCases', data).then(resp => {
      if (resp.success) {
        if (resp.question && resp.question.length) {
          this.getHighlightedText();
          this.getStrikedText();
          this.setState({
            casesData: resp.question,
            isLoading: false,
            isDataLoading: false,
            vpCaseLoader: false,
            questionLoader: false,
            display_main_loader: 'hide_block',
            //selected case
            selectedQuestionData: resp.question[this.props.params.caseOffset],
            //all questions of selected case
            questionsData:
              resp.question[this.props.params.caseOffset] &&
                resp.question[this.props.params.caseOffset].cfa2_cbt_questions
                ? resp.question[this.props.params.caseOffset].cfa2_cbt_questions
                : [],
            //1st question of selected case
            selectedCaseQuestionData:
              resp.question[this.props.params.caseOffset] &&
                resp.question[this.props.params.caseOffset].cfa2_cbt_questions &&
                resp.question[this.props.params.caseOffset].cfa2_cbt_questions[
                this.props.params.quesOffset
                ]
                ? resp.question[this.props.params.caseOffset].cfa2_cbt_questions[
                this.props.params.quesOffset
                ]
                : [],
          });
        }
      } else {
        this.setState({
          isLoading: false,
          isDataLoading: false,
        });
      }
    });
  };

  changeCase = (questionNumber, index) => {
    const { casesData } = this.state;
    this.slider.slickGoTo(index + 1);
    this.getUserStats();
    // this.getFlagQuestions();
    this.setState({
      isLoading: true,
    });
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
    };
    if (questionNumber) {
      let pathname = AppRoutes.CFA2_CBT_QUESTIONS.replace(':id', this.props.params.id)
        .replace(':caseno', questionNumber)
        .replace(
          ':questiono',
          casesData[parseInt(this.props.params.caseOffset)] &&
            casesData[parseInt(this.props.params.caseOffset)].cfa2_cbt_questions[0]
            ? casesData[parseInt(this.props.params.caseOffset)].cfa2_cbt_questions[0].id
            : 1,
        )
        .replace(':timer', this.props.params.timer)
        .replace(':testid', this.props.params.testid)
        .replace(':caseOffset', index)
        .replace(':timerStart', this.props.params.timerStart)
        .replace(':isNegative', this.props.params.isNegative)
        .replace(':quesOffset', 0);
      this.context.router.push(
        {
          pathname,
        },
        this.getCases(data),
      );
    }
  };

  getUserStats = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getUsersStats', data).then(resp => {
      if (resp.success) {
        this.setState({
          userStatsData: resp.data,
          seconds: resp.data.user_time_value
            ? resp.data.user_time_value
            : parseInt(this.props.params.timer),
          isNegative: resp.data.isNegative,
        });
        attemptedCaseArray =
          resp.data.attemptedCases != null ? JSON.parse(resp.data.attemptedCases) : [];
      } else {
        this.setState({
          isLoading: false,
        });
      }
    });
  };

  changeQuestion = (questionNumber, index) => {
    if (questionNumber) {
      let pathname = AppRoutes.CFA2_CBT_QUESTIONS.replace(':id', this.props.params.id)
        .replace(':caseno', this.props.params.caseno)
        .replace(':questiono', questionNumber)
        .replace(':timer', this.props.params.timer)
        .replace(':testid', this.props.params.testid)
        .replace(':caseOffset', this.props.params.caseOffset)
        .replace(':quesOffset', index)
        .replace(':isNegative', this.props.params.isNegative)
        .replace(':timerStart', this.props.params.timerStart);

      this.context.router.push({
        pathname,
      });
    }
  };

  getNextCase = index => {
    const { casesData } = this.state;
    this.slider.slickGoTo(index);
    this.setState({
      isLoading: true,
    });
    let pathname = AppRoutes.CFA2_CBT_QUESTIONS.replace(':id', this.props.params.id)
      .replace(
        ':caseno',
        this.props.params.caseOffset ? casesData[parseInt(this.props.params.caseOffset) + 1].id : 1,
      )
      .replace(
        ':questiono',
        casesData[parseInt(this.props.params.caseOffset) + 1] &&
          casesData[parseInt(this.props.params.caseOffset) + 1].cfa2_cbt_questions[0]
          ? casesData[parseInt(this.props.params.caseOffset) + 1].cfa2_cbt_questions[0].id
          : 1,
      )
      .replace(':timer', this.props.params.timer)
      .replace(':testid', this.props.params.testid)
      .replace(
        ':caseOffset',
        this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) + 1 : 1,
      )
      .replace(':quesOffset', 0)
      .replace(':isNegative', this.props.params.isNegative)
      .replace(':timerStart', this.props.params.timerStart);

    this.context.router.push({
      pathname,
    });
  };

  getPreviousCase = index => {
    const { casesData } = this.state;
    this.slider.slickGoTo(index - 2);
    this.setState({
      isLoading: true,
    });
    let pathname = AppRoutes.CFA2_CBT_QUESTIONS.replace(':id', this.props.params.id)
      .replace(
        ':caseno',
        this.props.params.caseOffset ? casesData[parseInt(this.props.params.caseOffset) - 1].id : 1,
      )
      .replace(
        ':questiono',
        casesData[parseInt(this.props.params.caseOffset) - 1] &&
          casesData[parseInt(this.props.params.caseOffset) - 1].cfa2_cbt_questions[0]
          ? casesData[parseInt(this.props.params.caseOffset) - 1].cfa2_cbt_questions[0].id
          : 1,
      )
      .replace(':timer', this.props.params.timer)
      .replace(':testid', this.props.params.testid)
      .replace(
        ':caseOffset',
        this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) - 1 : 1,
      )
      .replace(':quesOffset', 0)
      .replace(':isNegative', this.props.params.isNegative)
      .replace(':timerStart', this.props.params.timerStart);

    this.context.router.push({
      pathname,
    });
  };

  getPreviousQuestion = index => {
    const { questionsData } = this.state;
    let pathname = AppRoutes.CFA2_CBT_QUESTIONS.replace(':id', this.props.params.id)
      .replace(':caseno', this.props.params.caseOffset)
      .replace(
        ':questiono',
        this.props.params.quesOffset
          ? questionsData[parseInt(this.props.params.quesOffset) - 1].id
          : 1,
      )
      .replace(':timer', this.props.params.timer)
      .replace(':testid', this.props.params.testid)
      .replace(':caseOffset', this.props.params.caseOffset)
      .replace(
        ':quesOffset',
        this.props.params.quesOffset ? parseInt(this.props.params.quesOffset) - 1 : 1,
      )
      .replace(':isNegative', this.props.params.isNegative)
      .replace(':timerStart', this.props.params.timerStart);

    this.context.router.push({
      pathname,
    });
  };

  getNextQuestion = index => {
    const { questionsData } = this.state;
    let pathname = AppRoutes.CFA2_CBT_QUESTIONS.replace(':id', this.props.params.id)
      .replace(':caseno', this.props.params.caseOffset)
      .replace(
        ':questiono',
        this.props.params.quesOffset
          ? questionsData[parseInt(this.props.params.quesOffset) + 1].id
          : 1,
      )
      .replace(':timer', this.props.params.timer)
      .replace(':testid', this.props.params.testid)
      .replace(':caseOffset', this.props.params.caseOffset)
      .replace(
        ':quesOffset',
        this.props.params.quesOffset ? parseInt(this.props.params.quesOffset) + 1 : 1,
      )
      .replace(':isNegative', this.props.params.isNegative)
      .replace(':timerStart', this.props.params.timerStart);
    this.context.router.push({
      pathname,
    });
  };

  addHighlight = async text => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const { selectedQuestionData } = this.state;

    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      type: 'highlight',
      text: text,
    };
    await FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/addHighlightedText', data).then(
      async res => {
        this.setState({ showPopover: false });
        await this.getHighlightedText();
        clearSelection();
      },
    );
  };

  deleteHighlight = async id => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));

    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: id,
    };

    if (id) {
      await FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/deleteHighlightedText', data).then(
        async res => {
          this.setState({ showPopover: false });
          await this.getHighlightedText();
          clearSelection();
        },
      );
    } else {
      return;
    }
  };

  getHighlightedText = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getHighlightedText', data).then(
      async res => {
        // console.log('highlights ---------> ', res.questions);
        this.setState({
          highlights: res.questions,
        });
      },
    );
  };

  getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    //console.log('userAgent', userAgent);
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    return 'unknown';
  };

  clickOption = async (choice, questionId, selectedQuestionData, e) => {
    //console.log('e. type ___________', e.type);
    e.preventDefault();
    // on left click
    if (e.type === 'click') {
      //console.log('Left click');
      // console.log('Print params ---------> ', this.props.params);
      const userData = {
        token: this.state.token,
        idname: this.state.idname,
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
        choice: choice,
        questionId: questionId,
        id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
        offset: this.props.params.quesOffset ? parseInt(this.props.params.quesOffset) : null,
        caseno: this.props.params.caseno ? parseInt(this.props.params.caseno) : null,
        caseOffset: this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : null,
        // attemptedCases: JSON.stringify(attemptedCaseArray),
      };
      this.updateSelectedChoice(userData, selectedQuestionData, choice);
    } else if (e.type === 'contextmenu') {
      //console.log('Right click');
      //on right click
      this.addStrikeThrough(choice);
    }
  };

  addStrikeThrough = async choice => {
    //console.log('inside call apiiiii', choice);
    const { selectedQuestionData } = this.state;
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      choice: choice,
    };

    await FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/addStrikeThrough', data).then(
      async res => {
        //console.log('resssssssssssssssss', res);
        // this.setState({ showPopover: false });
        await this.getStrikedText();
        // clearSelection();
      },
    );
    // };
  };

  updateSelectedChoice = (userData, selectedQuestionData, choice) => {
    // console.log('userData --------------> ', userData);
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/updateUsersChoice', userData).then(
      async res => {
        if (res.success) {
          const ansData = {
            token: this.state.token,
            idname: this.state.idname,
            mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
            question_id: selectedQuestionData.id,
            answer:
              selectedQuestionData && selectedQuestionData.answer === choice
                ? 'correct'
                : 'incorrect',
            test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
            reading_id: selectedQuestionData.chapter_id,
          };
          this.getUserStats();
          // console.log('ansData -------------> ', ansData);
          FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/updateUserAnswer', ansData).then(
            async res => { },
          );
        }
      },
    );
  };

  countDown() {
    const { runDecrement } = this.state;
    let seconds;
    if (this.state.seconds != 0 && runDecrement && this.props.params.isNegative === 'true') {
      seconds = this.state.seconds - 1;
    } else {
      seconds = this.state.seconds + 1;
      let pathname = AppRoutes.CFA2_CBT_QUESTIONS.replace(':id', this.props.params.id)
        .replace(':caseno', this.props.params.caseno)
        .replace(':questiono', this.props.params.questiono)
        .replace(':timer', this.props.params.timer)
        .replace(':testid', this.props.params.testid)
        .replace(':caseOffset', this.props.params.caseOffset)
        .replace(':quesOffset', this.props.params.quesOffset)
        .replace(':isNegative', false)
        .replace(':timerStart', this.props.params.timerStart);
      this.context.router.push({
        pathname,
      });
      this.setState({
        runDecrement: false,
      });
    }
    this.setState({
      seconds: seconds,
    });

    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      timer: seconds,
      isNegative: this.props.params.isNegative,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/updateUserTimer', data).then(async res => {
      if (res.success) {
      }
    });
  }

  submitTest = () => {
    const { questionsData } = this.state;
    this.setState({
      showFinishTestPopup: false,
    });
    // console.log('I am here for you ----------->');

    //api to update status of quiz
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      status: 'completed',
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/updateUserQuizStatus', data).then(
      async res => {
        if (res.success) {
        }
      },
    );

    const ansdata = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getrightAnswer', ansdata).then(
      resp_count => {
        // console.log('I am here for you ----------->');
        if (resp_count.success) {
          const data = {
            token: this.state.token,
            idname: this.state.idname,
            mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
            score: resp_count.allrightanswercount.question_count,
            id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
          };
          FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/updateUserScore', data);
        } else {
          //console.log(resp_count.success + '------------failure');
        }
      },
    );
    // /:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer
    let pathname = AppRoutes.CFA2_CBT_QUESTIONS_FINISH.replace(':id', this.props.params.id)
      .replace(':caseno', 0)
      .replace(':questiono', 1)
      .replace(':testid', this.props.params.testid)
      .replace(':caseOffset', 0)
      .replace(':quesOffset', 0)
      .replace(':timer', this.props.params.timer);

    this.context.router.push({
      pathname,
    });
  };

  flagQuestion = data => {
    const { flag } = this.state;
    let flaggedQuestions = flag.filter(flag => flag.question_id === data.id)[0];
    const flagdata = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: data.id,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    if (flaggedQuestions) {
      showSuccess('Question Unflagged');
    } else {
      showSuccess('Question Flagged');
    }
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/flagQuestion', flagdata).then(
      async res => {
        if (res) {
          this.getFlagQuestions();
        }
      },
    );
  };

  updateAttemptedCases = () => {
    // console.log('661 attempted cases -----------> ', attemptedCaseArray);
    const userData = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      attemptedCases: JSON.stringify(attemptedCaseArray),
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/updateAttemptedCases', userData).then(
      async res => {
        if (res.success) {
          attemptedCaseArray = res.attemptedCases != null ? JSON.parse(res.attemptedCases) : [];
        }
      },
    );
  };

  getFlagQuestions = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getflaggedQuestions', data).then(
      async res => {
        if (res) {
          this.setState({ flag: res.data });
        }
      },
    );
  };

  changeFilter = (e, type) => {
    const { target } = e;
    const { checked } = target;
    const { filter } = this.state;
    if (checked) {
      let temp = [...filter];
      temp.push(type);
      this.setState({
        filter: temp,
      });
    } else {
      // to uncheck elements
      let prevArray = filter.filter(item => item !== type);
      this.setState({
        filter: prevArray,
      });
    }
  };

  finishTest = () => {
    const { flag, userStatsData, totalQuestionCount } = this.state;
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
    if (flag && flag.length) {
      this.setState({
        showFlaggedPopup: true,
      });
    } else if (Object.keys(userChoice).length !== totalQuestionCount) {
      this.setState({
        showNonAttemptedPopup: true,
      });
    } else {
      this.setState({ showFinishTestPopup: true });
    }
  };

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  stopTimer = () => {
    const { timerStart } = this.state;
    if (timerStart === 'true') {
      this.setState({
        timerStart: 'false',
      });
      let pathname = AppRoutes.CFA2_CBT_QUESTIONS.replace(':id', this.props.params.id)
        .replace(':caseno', this.props.params.caseno)
        .replace(':questiono', this.props.params.questiono)
        .replace(':timer', this.props.params.timer)
        .replace(':testid', this.props.params.testid)
        .replace(':caseOffset', this.props.params.caseOffset)
        .replace(':quesOffset', this.props.params.quesOffset)
        .replace(':timerStart', false)
        .replace(':isNegative', this.props.params.isNegative);

      this.context.router.push({
        pathname,
      });
      clearInterval(this.timer);
    } else {
      this.setState({
        timerStart: 'true',
      });

      let pathname = AppRoutes.CFA2_CBT_QUESTIONS.replace(':id', this.props.params.id)
        .replace(':caseno', this.props.params.caseno)
        .replace(':questiono', this.props.params.questiono)
        .replace(':timer', this.props.params.timer)
        .replace(':testid', this.props.params.testid)
        .replace(':caseOffset', this.props.params.caseOffset)
        .replace(':quesOffset', this.props.params.quesOffset)
        .replace(':timerStart', true)
        .replace(':isNegative', this.props.params.isNegative);

      this.context.router.push({
        pathname,
      });
      this.timer = setInterval(this.countDown, 1000);
    }
  };

  addHighlightToText = () => {
    let text = this.getSelectionHtml();
    this.addHighlight(text);
  };

  deleteHighlightFromText = () => {
    let text = this.getSelectionHtml();

    const { highlights } = this.state;
    let getHighlightedTextData = highlights
      ? highlights.filter(item => {
        return item.text === text;
      })[0]
      : [];

    this.deleteHighlight(getHighlightedTextData.id);
  };

  getStrikedText = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getStrikedText', data).then(async res => {
      if (res && res.questions) {
        this.setState({
          strikeThroughArr: JSON.parse(res.questions.choiceArray),
        });
      } else {
        this.setState({
          strikeThroughArr: [],
        });
      }
    });
  };

  getSelectionHtml = () => {
    var html = '';
    if (typeof window.getSelection != 'undefined') {
      var sel = window.getSelection();
      //console.log('heyyyyyyyyyyyyyyyy', sel);
      if (sel.rangeCount) {
        var container = document.createElement('div');
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents());
        }
        html = container.innerHTML;
      }
    } else if (typeof document.selection != 'undefined') {
      if (document.selection.type == 'Text') {
        html = document.selection.createRange().htmlText;
      }
    }
    return html;
  };

  // for IOS
  onTouchStart = (e, choice) => {
    e.preventDefault();
    // console.log(' window.navigator', window.navigator);
    const data = this.getMobileOperatingSystem();
    //console.log('datadata', data);
    if (data === 'Android') {
      return;
    } else {
      this.longPressCountdown = setTimeout(() => {
        //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
        this.addStrikeThrough(choice);
      }, longPressDuration);
    }
  };

  onTouchMove = e => {
    clearTimeout(this.longPressCountdown);
  };

  onTouchCancel = e => {
    clearTimeout(this.longPressCountdown);
  };

  onTouchEnd = e => {
    clearTimeout(this.longPressCountdown);
  };

  render() {
    const {
      isLoading,
      questionsData,
      showFinishTestPopup,
      userStatsData,
      mockName,
      flag,
      showSectionReview,
      showNonAttemptedPopup,
      showFlaggedPopup,
      filter,
      selectedQuestionData,
      seconds,
      timerStart,
      highlights,
      strikeThroughArr,
      casesData,
      selectedCaseQuestionData,
    } = this.state;
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
    const formatTimeF = SecondsToHHMMSS(seconds);
    let flaggedQuestion = flag.filter(flag => flag.question_id === selectedCaseQuestionData.id)[0];
    const sliderSettings = questionsettings(
      this.props.params.offset ? parseInt(this.props.params.offset) : 1,
    );
    const topSliderSettings = caseCV(
      this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : 1,
    );
    let content = selectedCaseQuestionData ? selectedCaseQuestionData.question : null;
    if (highlights) {
      highlights.forEach(element => {
        content = highlightString(content, element.text);
      });
    }
    let text = this.getSelectionHtml();
    let highlighted = `<b style="background-color: yellow" title="highlighted">${text}</b>`;
    let getHighlightedText = content ? content.indexOf(highlighted) : null;
    var parseResult = Object.keys(userChoice).map(function (x) {
      return parseInt(x, 10);
    });
    let count = 0;
    parseResult.forEach(element => {
      // console.log('element -----> ', element);
      let attemptedCount = questionsData.filter(item => {
        // console.log('iteme ----> ', item);
        if (item.id === element) {
          count++;
          if (questionsData.length === count) {
            if (attemptedCaseArray.indexOf(item.case_id) === -1) {
              attemptedCaseArray.push(item.case_id);

              this.updateAttemptedCases();
            }
          }
        }
        return item.id === element;
      });
    });
    let caseAttempted = '';
    if (questionsData.length === count) {
      caseAttempted = 'bg-completed-cases';
    }
    return (
      <div>
        <div className='animated fadeIn'>
          {isLoading ? (
            <Loader />
          ) : (
            <div
              className={
                casesData
                  ? casesData.length < 15
                    ? 'margin_bottom_20 ques-title-wrapper pl-0'
                    : 'margin_bottom_20 ques-title-wrapper'
                  : null
              }
            >
              <h1 className='section_head'>{mockName}</h1>
              <div className='finish-btn-wrapper'>
                <Button onClick={() => this.finishTest()} className='pointer_class btn-primary'>
                  {language.LC().Finish_Test}
                </Button>
              </div>
            </div>
          )}
          {isLoading ? (
            <Loader />
          ) : casesData && casesData.length ? (
            <div>
              <div className='row'>
                <div className='col-md-12'>
                  <div
                    className={
                      casesData.length > 15 ? 'case-tab-wrapper' : 'case-tab-wrapper padding-10'
                    }
                  >
                    <Slider
                      {...topSliderSettings}
                      ref={slider => {
                        this.slider = slider;
                      }}
                    >
                      {casesData.map((item, index) => {
                        return (
                          <button
                            key={index}
                            onClick={() => this.changeCase(item.id, index)}
                            className={`${attemptedCaseArray.indexOf(item.id) === -1
                              ? ''
                              : 'bg-completed-cases '
                              }
                              ${index === parseInt(this.props.params.caseOffset)
                                ? 'active button-trial'
                                : 'button-trial'
                              }`}
                          >
                            {index + 1}
                          </button>
                        );
                      })}
                    </Slider>
                  </div>
                </div>
                <div className='' />
                <div className='case-detail-wrapper col-md-12'>
                  <div className='card'>
                    <div className='card-header d-flex justify-content-between qus-header'>
                      {selectedQuestionData && selectedQuestionData.case ? (
                        <div className="ques-wrapper all-ques">
                         {renderHTMLContent(selectedQuestionData.case_name, "h1", "text-center mb-2 text-capitalize")}
                         {renderHTMLContent(selectedQuestionData.case, "div", "font-weight-normal", { contentEditable: false })}
                        </div>
                      ) : null}
                      <div className='text-right'>
                        <i
                          className={
                            this.props.params.caseOffset === '0'
                              ? `fa fa-angle-left ques_arrow pointer_class hide_block`
                              : `fa fa-angle-left ques_arrow pointer_class`
                          }
                          onClick={() => this.getPreviousCase(this.props.params.caseOffset)}
                        />
                        <i
                          className={
                            parseInt(this.props.params.caseOffset) === casesData.length - 1
                              ? `fa fa-angle-right ques_arrow pointer_class hide_block`
                              : `fa fa-angle-right ques_arrow pointer_class`
                          }
                          onClick={() => this.getNextCase(this.props.params.caseOffset)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className='row '>
                  <div className='qus-tab-wrapper'>
                    {questionsData.map((item, index) => {
                      let flaggedQuestions = flag.filter(flag => flag.question_id === item.id)[0];

                      return (
                        <div className='slide-button' key={index}>
                          <Button
                            onClick={() => this.changeQuestion(item.id, index)}
                            className={`
                            ${index === parseInt(this.props.params.quesOffset) ? 'active' : ''}
                            ${userChoice[item.id] ? 'completed-qus' : ''}
                            ${flaggedQuestions ? 'flag-add' : ''}
                            `}
                          >
                            {index + 1}
                            {flaggedQuestions ? (
                              <img
                                width='70'
                                src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                                alt='Question'
                              />
                            ) : (
                              ''
                            )}
                          </Button>
                        </div>
                      );
                    })}
                  </div>
                  <div className='ques-detail-wrapper col-md-12 question-wrapper'>
                    {
                      <div className='card'>
                        <div className='card-block'>
                          <div className='row'>
                            <div className={'main_loader ' + this.state.display_main_loader}>
                              <div className='loader-mid'>
                                <div className='card-block-loader'>
                                  <Loader />
                                </div>
                              </div>
                            </div>
                            <div className='col-sm-8 col-lg-9'>
                              {selectedCaseQuestionData && selectedCaseQuestionData.question ? (
                                <div className='qus-wrapper ques-bold-remove d-block all-ques'>
                                  <div>
                                    <img
                                      src={
                                        App_data.frontend_url +
                                        '/img/question_bank/question_icon_blue.svg'
                                      }
                                      className='margin_right_20'
                                      alt=''
                                      width='30'
                                    />
                                    Q.
                                    {parseInt(this.props.params.quesOffset) + 1}
                                  </div>
                                  <div
                                    style={{
                                      position: 'relative',
                                      marginTop: '8px',
                                      maxWidth: '100%',
                                    }}
                                  >
                                    <div data-selectable>
                                    {renderHTMLContent(content, "div", "qus-title d-inline-block w-100")}
                                    </div>
                                    <SelectionPopover
                                      showPopover={this.state.showPopover}
                                      onSelect={() => {
                                        this.setState({
                                          showPopover: true,
                                        });
                                      }}
                                      onDeselect={() => {
                                        this.setState({
                                          showPopover: false,
                                        });
                                      }}
                                    >
                                      {getHighlightedText === -1 ? (
                                        <div className='highlight-popover tooltip_wrap'>
                                          <img
                                            src={App_data.frontend_url + '/img/high-edit-ico.svg'}
                                            alt='523'
                                            width='30'
                                            onClick={() => this.addHighlightToText()}
                                          />
                                          <div className='tootip_box'>
                                            {language.LC().Click_me_to_highlight}
                                          </div>
                                        </div>
                                      ) : (
                                        <div className='highlight-popover tooltip_wrap'>
                                          <img
                                            src={
                                              App_data.frontend_url + '/img/icon_select_text.png'
                                            }
                                            alt='523'
                                            width='30'
                                            onClick={() => this.deleteHighlightFromText()}
                                          />
                                          <div className='tootip_box'>
                                            {language.LC().Click_me_to_unhighlight}
                                          </div>
                                        </div>
                                      )}
                                    </SelectionPopover>
                                  </div>
                                </div>
                              ) : null}
                              {/* </div> */}
                              <div className='row'>
                                {optionsArr.map((item, index) => {
                                  return (
                                    <div
                                      className='col-sm-12'
                                      id={item}
                                      key={index}
                                      onClick={e => {
                                        this.clickOption(
                                          item,
                                          selectedCaseQuestionData && selectedCaseQuestionData.id
                                            ? selectedCaseQuestionData.id
                                            : null,
                                          selectedCaseQuestionData,
                                          e,
                                        );
                                      }}
                                      onContextMenu={e => {
                                        this.clickOption(
                                          item,
                                          selectedCaseQuestionData && selectedCaseQuestionData.id
                                            ? selectedCaseQuestionData.id
                                            : null,
                                          selectedCaseQuestionData,
                                          e,
                                        );
                                      }}
                                      onTouchStart={e => {
                                        this.onTouchStart(e, item);
                                      }}
                                      onTouchCancel={e => {
                                        this.onTouchCancel(e);
                                      }}
                                      onTouchEnd={e => {
                                        this.onTouchEnd(e);
                                      }}
                                      onTouchMove={e => {
                                        this.onTouchMove(e);
                                      }}
                                    >
                                      <div
                                        className={`answer_box ${userChoice[selectedCaseQuestionData.id] === item
                                          ? `border-yellow`
                                          : 'border-black'
                                          }`}
                                      >
                                        <div
                                          className={`answer_count highlight_choice no-selection ${item === 'choice_a'
                                            ? strikeThroughArr.includes('choice_a')
                                              ? 'strikethrough'
                                              : ''
                                            : item === 'choice_b'
                                              ? strikeThroughArr.includes('choice_b')
                                                ? 'strikethrough'
                                                : ''
                                              : item === 'choice_c'
                                                ? strikeThroughArr.includes('choice_c')
                                                  ? 'strikethrough'
                                                  : ''
                                                : ''
                                            }`}
                                        >
                                          {item === 'choice_a'
                                            ? language.LC().A
                                            : item === 'choice_b'
                                              ? language.LC().B
                                              : language.LC().C}
                                        </div>
                                        <p
                                          className={`ans_box_text tooltip_wrap ${item === 'choice_a'
                                            ? strikeThroughArr.includes('choice_a')
                                              ? 'strikethrough'
                                              : ''
                                            : item === 'choice_b'
                                              ? strikeThroughArr.includes('choice_b')
                                                ? 'strikethrough'
                                                : ''
                                              : item === 'choice_c'
                                                ? strikeThroughArr.includes('choice_c')
                                                  ? 'strikethrough'
                                                  : ''
                                                : ''
                                            }`}
                                        >
                                          {selectedCaseQuestionData && selectedCaseQuestionData[item] ? (
                                            renderHTMLContent(selectedCaseQuestionData[item], "span", "no-selection", { contentEditable: false })
                                          ) : null}
                                        </p>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                            <div className='col-sm-4 col-lg-3'>
                              <div className='timer_outer mb-15'>
                                <div>
                                  <h2 className='time-left-heading'>{language.LC().TIME_LEFT}</h2>
                                  <span
                                    className={`timer_box ${this.props.params.isNegative === 'false' ? 'blink' : null
                                      }`}
                                  >
                                    {this.props.params.isNegative === 'false'
                                      ? `- ${formatTimeF}`
                                      : formatTimeF}
                                  </span>
                                </div>
                              </div>
                              <button
                                type='button'
                                aria-label={timerStart === 'true' ? 'Pause timer and take a break' : 'Resume timer'}
                                className={`tooltip_wrap mb-2 hover-pad-same
                                ${timerStart === 'true'
                                    ? 'icon-control-pause pause_btn'
                                    : 'pause_btn icon-control-play'
                                  }`}
                                onClick={() => this.stopTimer()}
                              >
                                <div className='tootip_box' aria-hidden='true'>
                                  {language.LC().Save_and_Take_Break}
                                </div>
                              </button>
                            </div>
                            <div className='col-sm-3 d-sm-flex align-items-end text-center text-sm-left mt-1'>
                              <button
                                type='button'
                                aria-label={language.LC().SECTION_REVIEW}
                                className='menu-btn tooltip-hover-questions'
                                onClick={() => {
                                  this.setState({
                                    showSectionReview: true,
                                  });
                                }}
                              >
                                <img
                                  width='30px'
                                  src={App_data.frontend_url + '/img/questions/icon_menu.png'}
                                  className='my-1'
                                  alt=''
                                />
                                <div className='tootip_box' aria-hidden='true'>{language.LC().SECTION_REVIEW}</div>
                              </button>
                            </div>
                            <div className='col-sm-9 mt-1'>
                              <div className='text-center text-sm-right btm-btn-wrapper quiz-submit-block'>
                                <span className='up tooltip-hover-questions quiz-flag'>
                                  {flaggedQuestion ? (
                                    <div className='tootip_box'>
                                      {language.LC().UNFLAG_THIS_QUESTION}
                                    </div>
                                  ) : (
                                    <div className='tootip_box'>
                                      {language.LC().FLAG_THIS_QUESTION}
                                    </div>
                                  )}
                                  <i
                                    onClick={() => this.flagQuestion(selectedCaseQuestionData)}
                                    className={
                                      flaggedQuestion
                                        ? `fa fa-flag mark-action-btn`
                                        : `fa fa-flag-o mark-action-btn`
                                    }
                                  >
                                    {' '}
                                  </i>
                                </span>

                                <Button
                                  onClick={() =>
                                    this.getPreviousQuestion(this.props.params.quesOffset)
                                  }
                                  className='pointer_class btn-primary'
                                  disabled={parseInt(this.props.params.quesOffset) === 0}
                                >
                                  <i className='fa fa-angle-left' /> {language.LC().BACK}
                                </Button>
                                <Button
                                  onClick={() => this.getNextQuestion(this.props.params.quesOffset)}
                                  className='pointer_class btn-primary'
                                  disabled={
                                    parseInt(this.props.params.quesOffset) ===
                                    questionsData.length - 1
                                  }
                                >
                                  {language.LC().NEXT} <i className='fa fa-angle-right' />
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className='no-qus-found'>
              <img width='105px' src={App_data.frontend_url + '/img/questions/problem.png'} alt='' />
              <h3>{language.LC().NO_QUESTION_FOUND}</h3>
              <p> {language.LC().NO_QUESTION_FOR_THIS_EXAM}</p>
            </div>
          )}
        </div>
        {/* =========For Side Bar S============ */}
        <div className={`sidebar-review-wrapper ${showSectionReview ? 'active' : ''}`}>
          <div className='header-review'>
            <h2>{language.LC().SECTION_REVIEW}</h2>
            <button
              type='button'
              aria-label='Close section review'
              className='section-review-close'
              onClick={() => {
                this.setState({
                  showSectionReview: false,
                });
              }}
            >
              <img width='30px' src={App_data.frontend_url + '/img/questions/icon_close.png'} alt='' />
            </button>
          </div>
          <div className='body-review'>
            <h3>{language.LC().FILTER_BY}:</h3>
            <div className='filt-list-wrapper'>
              <button
                className='btn btn-primary small-btn'
                onClick={() => {
                  this.setState({
                    filter: [],
                  });
                }}
              >
                {language.LC().CLEAR}
              </button>
              <ul>
                {filterObj.map((item, index) => {
                  return (
                    <li className='plan_wrapper remove-plan' key={index}>
                      <label className='check_container'>
                        <input
                          type='checkbox'
                          value={item}
                          id={item}
                          checked={filter.indexOf(item) > -1 ? true : false}
                          onChange={e => this.changeFilter(e, item)}
                        />
                        <span className='checkmark' /> {item}
                      </label>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className='qus-tab-wrapper'>
              {questionsData.map((item, index) => {
                let flaggedQuestions = flag.filter(flag => flag.question_id === item.id)[0];
                return (
                  <div key={index}>
                    {filter.includes('Attempted') &&
                      filter.includes('Unattempted') &&
                      filter.includes('Flagged') ? (
                      <Button
                        className={`${userChoice[item.id] ? 'completed-qus' : ''} ${flaggedQuestions ? 'flag-add' : ''
                          }`}
                        onClick={() => {
                          this.setState({
                            showSectionReview: false,
                          });
                          this.changeQuestion(item.id, index);
                        }}
                      >
                        {index + 1}
                        {flaggedQuestions ? (
                          <img
                            width='70'
                            src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                            alt='Question'
                          />
                        ) : (
                          ''
                        )}
                      </Button>
                    ) : filter.includes('Attempted') && filter.includes('Unattempted') ? (
                      <Button
                        className={`${userChoice[item.id] ? 'completed-qus' : ''}`}
                        onClick={() => {
                          this.setState({
                            showSectionReview: false,
                          });
                          this.changeQuestion(item.id, index);
                        }}
                      >
                        {index + 1}
                      </Button>
                    ) : filter.includes('Unattempted') && filter.includes('Flagged') ? (
                      !userChoice[item.id] && flaggedQuestions ? (
                        <Button
                          className={` ${flaggedQuestions ? 'flag-add' : ''}`}
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}
                          {flaggedQuestions ? (
                            <img
                              width='70'
                              src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                              alt='Question'
                            />
                          ) : (
                            ''
                          )}
                        </Button>
                      ) : (
                        ''
                      )
                    ) : ///
                      filter.includes('Attempted') && filter.includes('Flagged') ? (
                        userChoice[item.id] && flaggedQuestions ? (
                          <Button
                            className={`${userChoice[item.id] ? 'completed-qus' : ''} ${flaggedQuestions ? 'flag-add' : ''
                              }`}
                            onClick={() => {
                              this.setState({
                                showSectionReview: false,
                              });
                              this.changeQuestion(item.id, index);
                            }}
                          >
                            {index + 1}
                            {flaggedQuestions ? (
                              <img
                                width='70'
                                src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                                alt='Question'
                              />
                            ) : (
                              ''
                            )}
                          </Button>
                        ) : (
                          ''
                        )
                      ) : filter.includes('Attempted') ? (
                        userChoice[item.id] ? (
                          <Button
                            className={'completed-qus'}
                            onClick={() => {
                              this.setState({
                                showSectionReview: false,
                              });
                              this.changeQuestion(item.id, index);
                            }}
                          >
                            {index + 1}
                          </Button>
                        ) : (
                          ''
                        )
                      ) : filter.includes('Unattempted') ? (
                        !userChoice[item.id] ? (
                          <Button
                            onClick={() => {
                              this.setState({
                                showSectionReview: false,
                              });
                              this.changeQuestion(item.id, index);
                            }}
                          >
                            {index + 1}
                          </Button>
                        ) : (
                          ''
                        )
                      ) : filter.includes('Flagged') ? (
                        flaggedQuestions ? (
                          <Button
                            className={`${userChoice[item.id] ? 'flag-add completed-qus' : 'flag-add '
                              }`}
                            onClick={() => {
                              this.setState({
                                showSectionReview: false,
                              });
                              this.changeQuestion(item.id, index);
                            }}
                          >
                            {index + 1}

                            <img
                              width='70'
                              src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                              alt='Question'
                            />
                          </Button>
                        ) : (
                          ''
                        )
                      ) : (
                        <Button
                          className={`${userChoice[item.id] ? 'completed-qus' : ''} ${flaggedQuestions ? 'flag-add' : ''
                            }`}
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}
                          {flaggedQuestions ? (
                            <img
                              width='70'
                              src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                              alt='Question'
                            />
                          ) : (
                            ''
                          )}
                        </Button>
                      )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* =========For Side Bar E============ */}
        <CBTFinishTest
          showFinishTestPopup={showFinishTestPopup}
          submitTest={() => this.submitTest()}
          handleClose={() => this.setState({ showFinishTestPopup: false })}
        />
        <CBTNonAttempted
          showFinishTestPopup={showNonAttemptedPopup}
          submitTest={() =>
            this.setState({
              showFinishTestPopup: true,
              showNonAttemptedPopup: false,
            })
          }
          handleClose={() => this.setState({ showNonAttemptedPopup: false })}
        />
        <CBTFlagged
          showFinishTestPopup={showFlaggedPopup}
          submitTest={() =>
            this.setState({
              showFlaggedPopup: false,
              showFinishTestPopup: true,
            })
          }
          handleClose={() => this.setState({ showFlaggedPopup: false })}
        />
      </div>
    );
  }
}

export default CFAQuestions;



// WEBPACK FOOTER //
// ./src/views/CBT/CFA2CBTNew/Questions/index.js